import { apiConfig } from 'config';
import {
  authApi,
  userApi,
  categoryApi,
  leagueApi,
  matchApi,
  siteAPi,
  countryApi,
  paymentApi,
  slideApi,
  sharedApi
} from 'services';

const api = apiConfig;

api.auth = authApi(api);
api.user = userApi(api);
api.category = categoryApi(api);
api.league = leagueApi(api);
api.match = matchApi(api);
api.site = siteAPi(api);
api.country = countryApi(api);
api.payment = paymentApi(api);
api.slide = slideApi(api);
api.shared = sharedApi(api);

export default api;
